module.exports = __webpack_public_path__ + "static/media/queen.583200a4.gif";